@if (initialized) {

    <!-- Header -->
    <h2 class="text-xl font-semibold mb-6">Create Documentation Page</h2>

    <div class="space-y-6 flex flex-column">

        <!-- Name -->
        <div class="flex w-full mb-4">
            <label class="col-4 text-sm font-medium mb-1">Name<span class="text-red">*</span>:</label>
            <input
                    [(ngModel)]="pageTitle"
                    type="text"
                    pInputText
                    class=""
            />
        </div>

        <!-- Page Type -->
        <div class="flex w-full mb-4">
            <label class="col-4  text-sm font-medium mb-1">Page Type:</label>
            <p-select
                    [options]="pageTypesDtoList?.entries"
                    [(ngModel)]="selectedPageType"
                    placeholder="Select Page Type"
                    optionLabel="name"
                    class=""
                    (onChange)="onSelectPageType()"
            ></p-select>
        </div>

        <!-- Object Type (if required) -->
        @if (selectedPageType && selectedPageType.linkedObjectTypeDtoId == undefined && selectedPageType.objectTypeRequired) {
            <div class="flex w-full mb-4">
                <label class="col-4 block text-sm font-medium mb-1">Object Type:</label>
                <p-select
                        [options]="objectTypesDtoList?.entries"
                        [(ngModel)]="selectedObjectType"
                        [filter]="true"
                        [loading]="busy"
                        placeholder="Select Object Type"
                        optionLabel="alias"
                        class="w-full"
                        (onChange)="onSelectObjectType()"
                ></p-select>
            </div>
        }

        <!-- Object Id Search -->
        @if (selectedObjectTypeName) {
            <div class="flex w-full mb-4">
                <label class="col-4 block text-sm font-medium mb-1">Object Id:</label>
                <mvs-entity-search
                        class=" "
                        [objectTypeAlias]="selectedObjectTypeName"
                        (onChange)="handleSelectObjectId($event)"
                ></mvs-entity-search>
            </div>
        }

        <!-- DcPage Search -->
        <div class="flex w-full mb-4">
            <label class="col-4 block text-sm font-medium mb-1">Parent:</label>

            @if (parentPageId) {
                <input
                        [(ngModel)]="parentPageId"
                        [disabled]="true"
                        type="number"
                        pInputText
                        class=""
                />
            } @else {
                <mvs-entity-search
                        class="w-full"
                        [objectTypeAlias]="'dc.DcPage'"
                        (onChange)="handleSelectPage($event)"
                ></mvs-entity-search>
            }


        </div>

        <!-- Priority -->
        <div class="flex w-full mb-4">
            <label class="col-4 block text-sm font-medium mb-1">Priority:</label>
            <input
                    [(ngModel)]="priority"
                    type="number"
                    pInputText
                    class=""
            />
        </div>

        <!-- Submit -->
        <div class="flex justify-content-end pt-4">
            <p-button
                    label="Create"
                    [disabled]="!pageTitle || pageTitle.trim() == '' || busy"
                    (onClick)="handleOnCreateDcPage()"
            ></p-button>
        </div>

    </div>

}